// Changelog entries, read from Firestore (changelog/{slug}, published with scripts/changelog.js).
// The pre-rendered /changelog page also carries the entries as JSON (<script id="changelog-data">).
// That copy is read here, before React replaces the pre-rendered markup, so the page shows the
// entries at once and then refreshes them from Firestore.
import { collection, getDocsFromServer, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

export const TYPE_LABELS = { new: 'New', improved: 'Improved', fixed: 'Fixed' };
export const DATA_SCRIPT_ID = 'changelog-data';

// The collection can also be edited by hand in the Firebase console, so skip anything malformed
const clean = docs => docs
  .filter(e => e && typeof e.title === 'string' && e.title.trim() && /^\d{4}-\d{2}-\d{2}$/.test(e.date))
  .map(e => ({
    slug: e.slug,
    title: e.title.trim(),
    date: e.date,
    types: Object.keys(TYPE_LABELS).filter(t => Array.isArray(e.types) && e.types.includes(t)), // New, Improved, Fixed order
    body: typeof e.body === 'string' ? e.body : '',
  }))
  .sort((a, b) => b.date.localeCompare(a.date) || a.slug.localeCompare(b.slug)); // newest first

const readPrerendered = () => {
  try {
    const script = document.getElementById(DATA_SCRIPT_ID);
    return script ? clean(JSON.parse(script.textContent)) : null;
  } catch {
    return null;
  }
};

// Last entries seen, so returning to the page doesn't show the loading state again
let latest = readPrerendered();

export const cachedEntries = () => latest;

// From the server only: offline, getDocs would answer with an empty cache and wipe the entries
export async function fetchEntries() {
  const snap = await getDocsFromServer(query(collection(db, 'changelog'), where('published', '==', true)));
  latest = clean(snap.docs.map(d => ({ ...d.data(), slug: d.id })));
  return latest;
}

// For the <script> copy: "<" is escaped so an entry can't close the script tag
export const serializeEntries = entries => JSON.stringify(entries).replace(/</g, '\\u003c');
